import type { OptionStates } from 'components/Form/CheckboxTreeFilterable'
import type { AbTestOption } from 'features/ab-tests/types/abTestParametersSchema'

type NestedParams = {
  [key: string]: AbTestOption | NestedParams | OptionStates | string
}

export const recursivelyAddDefaultOptionStates = (
  obj: NestedParams,
  defaultOptionStates: OptionStates,
): NestedParams => {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key]

    if (typeof value === 'object' && value !== null) {
      acc[key] = {
        ...value,
        ...defaultOptionStates,
        ...recursivelyAddDefaultOptionStates(value as NestedParams, defaultOptionStates),
      }
    } else {
      acc[key] = value
    }
    return acc
  }, {} as NestedParams)
}
